import Vue from 'vue';
import highlightjs from '@/vendor/highlight';

/**
 * The directive to highlight the code using highlight.js library.
 */
const directive = {
    deep: true,
    bind(el, binding) {
        const modifiers = Object.keys(binding.modifiers);

        if (binding.value) {
            modifiers.push(binding.value);
        }

        if (modifiers.length > 0) {
            el.classList.add(...modifiers);
        }

        highlightjs.highlightBlock(el);
    },
    componentUpdated: function componentUpdated(el, binding) {
        const modifiers = Object.keys(binding.modifiers);
        const oldModifiers = [];

        if (binding.value) {
            modifiers.push(binding.value);
            oldModifiers.push(binding.oldValue);
        }

        if (oldModifiers.length > 0) {
            el.classList.remove(...oldModifiers);
        }

        if (modifiers.length > 0) {
            el.classList.add(...modifiers);
        }

        highlightjs.highlightBlock(el);
    },
};

Vue.directive('highlight', directive);
